import React from 'react';
import './About.css';

const education = [
  {
    logo: '/about/harvard.webp',
    title: 'Harvard University',
    subtitle: 'Master in Design Engineering',
  },
  {
    logo: '/about/brown.webp',
    title: 'Brown University',
    subtitle: 'B.S. Computer Science',
  },
];

const work = [
  {
    logo: '/about/nasa.webp',
    title: 'NASA JPL',
    subtitle: 'Data visualization for the Mars Perseverance rover',
  },
  {
    logo: '/about/waymo.webp',
    title: 'Waymo',
    subtitle: 'Simulation for autonomous vehicle development',
  },
  {
    logo: '/about/google.webp',
    title: 'Google',
    subtitle: "Software engineer on Android, Gmail, and Wallet",
  },
];

function LogoGrid({ items }) {
  return (
    <div className="logo-grid">
      {items.map((item, idx) => (
        <div className="logo-item" key={idx}>
          <img src={item.logo} alt={item.title} className="logo-img" />
          <div className="logo-caption">
            <div className="logo-title">{item.title}</div>
            <div className="logo-subtitle">{item.subtitle}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function About() {
  return (
    <div className="about">
      <section className="about-hero">
        <img
          src="/about/headshot.webp"
          alt="Headshot"
          className="about-headshot"
        />
        <div className="about-content">
          <div className="about-bio">
            <h1>Hi, I'm Luke.</h1>
            <p>
              I'm a design engineer based in Cambridge, MA.
            </p>
            <br />
            <p>
              I believe the world's most complex challenges can't be solved in silos. I work at the intersection of design, technology, and systems thinking to build thoughtful, context-aware solutions. In doing so, I hope to unlock our collective capacity to imagine and implement meaningful change.
            </p>
          </div>
        </div>
      </section>

      <section className="about-contact">
        <h2>Let's connect</h2>
        <div>
          I'm always open to thoughtful conversations, collaborations, or new ideas. Reach me at <a href="mailto:luke@lukefiorante.com">luke@lukefiorante.com</a>.
        </div>
      </section>

      <section className="about-path">
        <div className="path-content">
          <h2 className="path-header">My path so far</h2>
          <div className="path-body">
            I've had the chance to work on a range of projects that span disciplines, geographies, and goals. Here are some of the steps along my journey.
          </div>
          <div className="path-grid">
            <LogoGrid items={education} />
            <div className="path-divider" />
            <LogoGrid items={work} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default About; 